    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">


                        <el-form-item label="用户:">
                            <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                                <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="类型:">
                            <el-input v-model="table.where.type" placeholder="请输入类型" clearable />
                        </el-form-item>

                        <el-form-item label="小区:">
                            <el-input v-model="table.where.village" placeholder="请输入小区" clearable />
                        </el-form-item>

                        <el-form-item label="分类:">
                            <el-select v-model="table.where.classify_id" filterable placeholder="请选择">
                                <el-option v-for="item in house_classify_list" :key="item.id" :label="item.title"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="面积:">
                            <el-input v-model="table.where.area" placeholder="请输入面积" clearable />
                        </el-form-item>

                        <el-form-item label="楼层:">
                            <el-input v-model="table.where.storey" placeholder="请输入楼层" clearable />
                        </el-form-item>

                        <el-form-item label="户型:">
                            <el-input v-model="table.where.size" placeholder="请输入户型" clearable />
                        </el-form-item>

                        <el-form-item label="朝向:">
                            <el-input v-model="table.where.face" placeholder="请输入朝向" clearable />
                        </el-form-item>

                        <el-form-item label="月金额:">
                            <el-input-number v-model="table.where.month_price" controls-position="right" :min="0"
                                :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入月金额"
                                clearable />
                        </el-form-item>


                        <el-form-item label="方式:">
                            <el-input v-model="table.where.way" placeholder="请输入方式" clearable />
                        </el-form-item>

                        <el-form-item label="标签:">
                            <el-input v-model="table.where.label" placeholder="请输入标签" clearable />
                        </el-form-item>



                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:house:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:house:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:house:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="user_id" label="用户" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.user_id_info"
                                    :key="index">{{item.nick_name+item.phone}}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="type" label="类型" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="village" label="小区" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="classify_id" label="分类" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.classify_id_info"
                                    :key="index">{{item.title}}</el-tag>
                            </template>
                        </el-table-column>


                        <el-table-column prop="area" label="面积" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="storey" label="楼层" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="size" label="户型" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="face" label="朝向" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="month_price" label="月金额" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="way" label="方式" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="label" label="标签" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="images" label="图片" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image v-for="(item,index) in row.images" :key="index"
                                    style="width: 50px; height: 50px" :src="item" :preview-src-list="row.images">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="classify_id_info.title" label="标题" sortable="custom"
                            show-overflow-tooltip min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.classify_id_info" :key="index">
                                    {{ item.title }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="classify_id_info.sort" label="排序" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.classify_id_info" :key="index">
                                    {{ item.sort }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:house:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此房源列表吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:house:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改房源列表':'添加房源列表'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">


                    <el-form-item label="用户:" prop="user_id">
                        <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>

                    <el-form-item label="类型:" prop="type">
                        <el-input v-model="editForm.type" placeholder="请输入类型" clearable />
                    </el-form-item>

                    <el-form-item label="小区:" prop="village">
                        <el-input v-model="editForm.village" placeholder="请输入小区" clearable />
                    </el-form-item>


                    <el-form-item label="分类:" prop="classify_id">
                        <el-select v-model="editForm.classify_id" filterable placeholder="请选择">
                            <el-option v-for="item in house_classify_list" :key="item.id" :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="面积:" prop="area">
                        <el-input v-model="editForm.area" placeholder="请输入面积" clearable />
                    </el-form-item>

                    <el-form-item label="楼层:" prop="storey">
                        <el-input v-model="editForm.storey" placeholder="请输入楼层" clearable />
                    </el-form-item>

                    <el-form-item label="户型:" prop="size">
                        <el-input v-model="editForm.size" placeholder="请输入户型" clearable />
                    </el-form-item>

                    <el-form-item label="朝向:" prop="face">
                        <el-input v-model="editForm.face" placeholder="请输入朝向" clearable />
                    </el-form-item>


                    <el-form-item label="月金额:" prop="month_price">
                        <el-input-number v-model="editForm.month_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入月金额"
                            clearable />
                    </el-form-item>

                    <el-form-item label="方式:" prop="way">
                        <el-input v-model="editForm.way" placeholder="请输入方式" clearable />
                    </el-form-item>

                    <el-form-item label="标签:" prop="label">
                        <el-input v-model="editForm.label" placeholder="请输入标签" clearable />
                    </el-form-item>


                    <el-form-item label="内容:" prop="content">
                        <tinymce-editor v-model="editForm.content" :init="initEditor" />
                    </el-form-item>


                    <el-form-item label="图片:" prop="images">
                        <ele-uploadimage :limit="9" v-model="editForm.images"></ele-uploadimage>

                    </el-form-item>


                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'
        import TinymceEditor from '@/components/TinymceEditor'

        export default {
            name: "SysHouse",
            components: {
                EleUploadimage,
                TinymceEditor,
            },
            data() {
                return {
                    table: {
                        url: '/house/House/index',
                        where: {
                            "images": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "images": []
                    }, // 表单数据
                    editFormTemp: {
                        "images": []
                    },
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    house_classify_list: [],
                    editRules: { // 表单验证规则

                        user_id: [{
                            required: true,
                            message: '请选择用户',
                            trigger: 'blur'
                        }],


                        type: [{
                            required: true,
                            message: '请输入类型',
                            trigger: 'blur'
                        }],


                        village: [{
                            required: true,
                            message: '请输入小区',
                            trigger: 'blur'
                        }],


                        classify_id: [{
                            required: true,
                            message: '请选择分类',
                            trigger: 'blur'
                        }],


                        area: [{
                            required: true,
                            message: '请输入面积',
                            trigger: 'blur'
                        }],


                        storey: [{
                            required: true,
                            message: '请输入楼层',
                            trigger: 'blur'
                        }],


                        size: [{
                            required: true,
                            message: '请输入户型',
                            trigger: 'blur'
                        }],


                        face: [{
                            required: true,
                            message: '请输入朝向',
                            trigger: 'blur'
                        }],


                        month_price: [{
                            required: true,
                            message: '请输入月金额',
                            trigger: 'blur'
                        }],


                        way: [{
                            required: true,
                            message: '请输入方式',
                            trigger: 'blur'
                        }],


                        label: [{
                            required: true,
                            message: '请输入标签',
                            trigger: 'blur'
                        }],


                        content: [{
                            required: true,
                            message: '请输入内容',
                            trigger: 'blur'
                        }],


                        images: [{
                            required: true,
                            message: '请上传图片',
                            trigger: 'blur'
                        }],


                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        title: [{
                            required: true,
                            message: '请输入标题',
                            trigger: 'blur'
                        }],



                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
                initEditor() {
                    return {
                        height: 400,
                        file_picker_callback: this.file_picker_callback,
                        skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                            '/tinymce/skins/ui/oxide',
                        content_css: this.$store.state.theme.theme === 'dark' ?
                            '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
                        images_upload_handler: (blobInfo, success, error) => {
                            let file = blobInfo.blob();
                            // 使用axios上传
                            const formData = new FormData();
                            formData.append('file', file, file.name);
                            this.$http.post('/upload/uploadImage', formData).then(res => {
                                if (res.data.code == 0) {
                                    success(res.data.data);
                                } else {
                                    error(res.data.msg);
                                }
                            }).catch(e => {
                                error(e.message);
                            });
                        }
                    };
                }
            },
            mounted() {

                this.userAllList();
                this.HouseClassifyAllList();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/house/House/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/house/House/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的房源列表吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/house/House/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/house/House/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 获取全部会员 */
                userAllList() {
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/house/House/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                HouseClassifyAllList() {
                    this.$http.post('/house/HouseClassify/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.house_classify_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>